<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div
          class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10 sm:tw--mt-1.5"
        >
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Delete Integration</h3>
          <div class="tw-mt-2 tw-font-thin tw-text-gray-600">
            <p>Are you sure you want to delete {{ integration.name }}?</p>
            <p class="tw-mt-2">This action is permanent and cannot be undone.</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="deleteIntegration" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Delete</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { TrashIcon } from "@/assets/svgs";

export default {
  components: {
    TrashIcon,
  },
  data() {
    return {
      isLoading: false,
      integration: {},
    };
  },
  methods: {
    show(integration) {
      this.$refs.modal.show();
      this.integration = integration;
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteIntegration() {
      try {
        this.isLoading = true;
        await this.$axios.delete(`/integrations/${this.integration.integrationId}`);
        this.hide();
        this.$emit("deleted", this.integration);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Integration Deleted", message: "The integration was successfully deleted" });
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to delete the integration",
          message: `We had a problem deleting integration ${this.integration.integrationId}. Please reload the page to try again.`,
          error,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
